import { useEffect, useState } from 'react'
import { getIngestStatus } from '../../../../services/analytics/analytics.service'

// Recordatorio de que la analítica es una FOTO periódica (ingest batch), no en vivo.
// Evita la confusión de "creé algo y no aparece" (se actualiza al re-ingestar).
const fmt = (iso) => {
  if (!iso) return null
  return new Date(iso).toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' })
}

const DataAsOf = () => {
  const [status, setStatus] = useState(null)

  useEffect(() => {
    let active = true
    getIngestStatus()
      .then((res) => {
        // El endpoint /ingest/status devuelve el objeto SIN envoltura `data`
        // ({ running, lastCompleted, ... }); toleramos ambas formas.
        if (active) setStatus(res?.data ?? res ?? null)
      })
      .catch(() => {})
    return () => {
      active = false
    }
  }, [])

  const when = fmt(status?.lastCompleted)
  const text = status?.running ? 'Refreshing…' : when ? `Data as of ${when}` : 'Not yet ingested'

  return (
    <span
      title='Analytics is a periodic snapshot, not live. Update it from Settings → Analytics data → Refresh now.'
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 11,
        color: '#98a2b3',
        whiteSpace: 'nowrap',
        marginTop: 4
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: status?.running ? '#e0a100' : when ? '#2e9e68' : '#cfd6e0'
        }}
      />
      {text}
    </span>
  )
}

export default DataAsOf
